import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "container-fluid h-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col mt-5" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "Choix course")
  ])
], -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_5 = { class: "col-12 col-lg-4 m-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_7 = { class: "row mt-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_9 = { class: "col bg-primary text-light text-start rounded pt-3 mx-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("u", null, "Attention:")
  ]),
  /*#__PURE__*/_createTextVNode(" Certaines courses, notamment les triathlons, ont un nombre de places limité et s'inscrire à la course ne garantit pas votre participation. ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", null, "confirmée", -1)
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Pour un athlète en équipe, l'inscription de l'équipe est considérée comme "),
  /*#__PURE__*/_createElementVNode("i", null, "confirmée"),
  /*#__PURE__*/_createTextVNode(" lorsqu'un certain nombre d'athlètes de l'équipe ont leur inscription confirmée (paiment et inscription validés par nos soins). ")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_15 = { class: "row mt-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)
const _hoisted_17 = { class: "col col-lg-4 text-start fw-bold" }
const _hoisted_18 = { class: "row m-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "" }, " Souhaitez-vous faire la course en équipe? ", -1)
const _hoisted_20 = { class: "ms-4 mt-2" }
const _hoisted_21 = { class: "form-check" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexRadioDefault1"
}, " Oui ", -1)
const _hoisted_23 = { class: "form-check" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexRadioDefault2"
}, " Non ", -1)
const _hoisted_25 = { class: "row mt-4" }
const _hoisted_26 = { class: "row m-2" }
const _hoisted_27 = { class: "col form-group" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "inputBirthDate" }, "Sélectionnez votre course: ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, null, -1)
const _hoisted_30 = ["value", "disabled"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 0,
  class: "row m-2"
}
const _hoisted_33 = { class: "col-12 form-group" }
const _hoisted_34 = { for: "inputCreateRace" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = { for: "inputCreateRace" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "row m-2 mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col form-group text-end" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "btn btn-primary"
    }, " Continuer ")
  ])
], -1)
const _hoisted_38 = { class: "row m-2 mt-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "" }, " Que souhaitez-vous faire? ", -1)
const _hoisted_40 = { class: "ms-4 mt-2" }
const _hoisted_41 = { class: "form-check" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexRadioDefault1"
}, " Rejoindre une équipe existante ", -1)
const _hoisted_43 = { class: "form-check" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexRadioDefault2"
}, " Créer une nouvelle équipe ", -1)
const _hoisted_45 = { class: "row mt-4" }
const _hoisted_46 = { class: "row m-2" }
const _hoisted_47 = { class: "col-12 col-lg form-group" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { for: "selectTeam" }, "Sélectionnez l'équipe à rejoindre: ", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, null, -1)
const _hoisted_50 = ["value", "disabled"]
const _hoisted_51 = { class: "row m-2" }
const _hoisted_52 = { class: "col form-group" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { for: "inputTeamPassword" }, "Mot de passe de l'équipe: ", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "row m-2 mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col text-end" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "btn btn-primary"
    }, " Rejoindre l'équipe ")
  ])
], -1)
const _hoisted_55 = { class: "row mt-4" }
const _hoisted_56 = { class: "row m-2" }
const _hoisted_57 = { class: "col form-group" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { for: "inputTeamName" }, "Nom de l'équipe: ", -1)
const _hoisted_59 = { class: "row m-2" }
const _hoisted_60 = { class: "col form-group" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { for: "inputCreatePassword" }, "Mot de passe: ", -1)
const _hoisted_62 = { class: "row m-2" }
const _hoisted_63 = { class: "col form-group" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { for: "inputCreatePassword" }, "Confirmer mot de passe: ", -1)
const _hoisted_65 = { class: "text-danger" }
const _hoisted_66 = { class: "row m-2" }
const _hoisted_67 = { class: "col-12 form-group" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { for: "inputCreateCategory" }, "Catégorie: ", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, null, -1)
const _hoisted_70 = ["value"]
const _hoisted_71 = { class: "row m-2" }
const _hoisted_72 = { class: "col-12 form-group" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { for: "inputCreateRace" }, "Course: ", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, null, -1)
const _hoisted_75 = ["value", "disabled"]
const _hoisted_76 = { key: 0 }
const _hoisted_77 = {
  key: 0,
  class: "row m-2"
}
const _hoisted_78 = { class: "col-12 form-group" }
const _hoisted_79 = { for: "inputCreateRace" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_81 = { for: "inputCreateRace" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "row m-2 mt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col text-end" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "btn btn-primary"
    }, " Créer l'équipe ")
  ])
], -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepBar = _resolveComponent("StepBar")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ErrorModal = _resolveComponent("ErrorModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_StepBar, { index: 2 })
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("p", null, [
            _createTextVNode(" Pour un athlète courant sans équipe, l'inscription est considérée comme "),
            _hoisted_11,
            _createTextVNode(" lorsque le paiement et l'inscription auront été validés par l'équipe des Courses des 24 Heures de l'INSA. ")
          ], 512), [
            [_vShow, _ctx.solo]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
              return (_openBlock(), _createElementBlock("ul", {
                class: "m-0",
                key: category.id
              }, [
                _createElementVNode("li", null, [
                  _createTextVNode(" Catégorie "),
                  _createElementVNode("strong", null, _toDisplayString(category.name), 1),
                  _createTextVNode(" -> " + _toDisplayString(category.minTeamMembers) + " inscriptions minimum ", 1)
                ])
              ]))
            }), 128))
          ], 512), [
            [_vShow, _ctx.team]
          ])
        ]),
        _hoisted_14
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("small", null, [
          _createVNode(_component_RouterLink, {
            class: "col text-end",
            to: "/"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Je souhaite m'inscrire plus tard (accéder à ma page) ")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "flexRadioDefault",
                  id: "team",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.soloOrTeam && _ctx.soloOrTeam(...args)))
                }, null, 32),
                _hoisted_22
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "flexRadioDefault",
                  id: "solo",
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.soloOrTeam && _ctx.soloOrTeam(...args)))
                }, null, 32),
                _hoisted_24
              ])
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_25, [
            _createElementVNode("form", {
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submitSoloRace()), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedRace) = $event))
                  }, [
                    _hoisted_29,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.soloRaces, (soloRace) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: soloRace.id,
                        value: soloRace.id,
                        disabled: _ctx.raceSoloIsComplete(soloRace.id)
                      }, [
                        _createTextVNode(_toDisplayString(soloRace.name +
                      (_ctx.raceSoloIsComplete(soloRace.id) ? " (Complète)" : "")) + " - ", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(soloRace.disciplines, (raceDiscipline, indexRaceDiscipline) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: raceDiscipline.id
                          }, [
                            _createTextVNode(_toDisplayString(raceDiscipline.discipline.name) + " (" + _toDisplayString(raceDiscipline.duration) + "h) ", 1),
                            (
                          indexRaceDiscipline < soloRace.disciplines.length - 1
                        )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_31, " / "))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ], 8, _hoisted_30))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.selectedRace]
                  ])
                ]),
                (_ctx.selectedRace)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("label", _hoisted_34, "Tarif standard: " + _toDisplayString(_ctx.getSoloRegularPrice()) + " € ", 1),
                        _hoisted_35,
                        _createElementVNode("label", _hoisted_36, "Tarif VAvantages: " + _toDisplayString(_ctx.getSoloVaPrice()) + " € ", 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_37
              ])
            ], 32)
          ], 512), [
            [_vShow, _ctx.solo]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "flexRadioDefault",
                  id: "joinTeam",
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.joinOrCreateTeam && _ctx.joinOrCreateTeam(...args)))
                }, null, 32),
                _hoisted_42
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  name: "flexRadioDefault",
                  id: "createTeam",
                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.joinOrCreateTeam && _ctx.joinOrCreateTeam(...args)))
                }, null, 32),
                _hoisted_44
              ])
            ])
          ], 512), [
            [_vShow, _ctx.team]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_45, [
            _createElementVNode("form", {
              onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.submitJoinTeam()), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    id: "selectTeam",
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.joinedTeamId) = $event))
                  }, [
                    _hoisted_49,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teams, (team) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: team.id,
                        value: team.id,
                        disabled: 
                      _ctx.teamIsComplete(team.id) || _ctx.raceIsComplete(team.race.id)
                    
                      }, _toDisplayString(team.name +
                      " " +
                      (_ctx.teamIsComplete(team.id) ? " (Complète)" : "") +
                      (_ctx.raceIsComplete(team.race.id) ? " (Course complète)" : "")), 9, _hoisted_50))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.joinedTeamId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _hoisted_53,
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: "form-control",
                    id: "inputTeamPassword",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.joinedTeamPassword) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.joinedTeamPassword]
                  ])
                ])
              ]),
              _hoisted_54
            ], 32)
          ], 512), [
            [_vShow, _ctx.joinTeam]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_55, [
            _createElementVNode("form", {
              onSubmit: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.submitCreateTeam()), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _hoisted_58,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    id: "inputTeamName",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.createdTeamName) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.createdTeamName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _hoisted_61,
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: "form-control",
                    id: "inputCreatePassword",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.createdTeamPassword) = $event)),
                    minlength: "8",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.createdTeamPassword]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _hoisted_64,
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    class: "form-control",
                    id: "inputConfirmPassword",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.createdTeamConfirmPassword) = $event)),
                    minlength: "8",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.createdTeamConfirmPassword]
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_65, " Les mots de passe ne correspondent pas. ", 512), [
                  [_vShow, _ctx.createdTeamPassword !== _ctx.createdTeamConfirmPassword]
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _hoisted_68,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    id: "inputCreateCategory",
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedCategory) = $event)),
                    onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.fetchRaces && _ctx.fetchRaces(...args))),
                    required: ""
                  }, [
                    _hoisted_69,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: category.id,
                        value: category.id
                      }, _toDisplayString(category.name) + " (" + _toDisplayString(category.minTeamMembers) + " à " + _toDisplayString(category.maxTeamMembers) + " personnes) ", 9, _hoisted_70))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.selectedCategory]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_71, [
                _withDirectives(_createElementVNode("div", _hoisted_72, [
                  _hoisted_73,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    id: "inputCreateRace",
                    "aria-label": "Default select example",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.createdTeamRace) = $event)),
                    required: ""
                  }, [
                    _hoisted_74,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.races, (race) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: race.id,
                        value: race.id,
                        disabled: _ctx.raceIsComplete(race.id)
                      }, [
                        _createTextVNode(_toDisplayString(race.name + (_ctx.raceIsComplete(race.id) ? " (Complète)" : "")) + " - ", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(race.disciplines, (raceDiscipline, indexRaceDiscipline) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: raceDiscipline.id
                          }, [
                            _createTextVNode(_toDisplayString(raceDiscipline.discipline.name) + " (" + _toDisplayString(raceDiscipline.duration) + "h) ", 1),
                            (indexRaceDiscipline < race.disciplines.length - 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_76, " / "))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ], 8, _hoisted_75))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.createdTeamRace]
                  ])
                ], 512), [
                  [_vShow, _ctx.races.length > 0]
                ])
              ]),
              (_ctx.createdTeamRace)
                ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("label", _hoisted_79, "Tarif standard: " + _toDisplayString(_ctx.getRegularPrice()) + " € ", 1),
                      _hoisted_80,
                      _createElementVNode("label", _hoisted_81, "Tarif VAvantages: " + _toDisplayString(_ctx.getVaPrice()) + " € ", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_82
            ], 32)
          ], 512), [
            [_vShow, _ctx.createTeam]
          ])
        ]),
        _hoisted_83
      ])
    ]),
    _withDirectives(_createVNode(_component_ErrorModal, { onCloseErrorModal: _ctx.toggleErrorModal }, null, 8, ["onCloseErrorModal"]), [
      [_vShow, _ctx.showErrorModal]
    ])
  ], 64))
}